import React, { useEffect, useState } from "react";
import { BoxStyled } from "./styledComponents/component";
import RouteQustion from "./Route";
import StartQuestion from "./startQuestion";
import EndQuestion from "./endQuestion";
import BoxAnswer from "./step/boxAnswer";
import BoxQuestion from "./step/boxQuestion";
import StepHeader from "./step/stepHeader";

import { insert_risk_questionOption } from "../../../redux/questionOption/insert_risk_questionOption";

import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
// import { handleNotificationAlertTryUpdate, handleNotificationAlertCatch } from "../../../common/method/handleNotificationAlert";
import { makeStyles } from '@material-ui/core';
import { actionTypes as actionOnlineExam } from './../../../redux/questionOption/select_online_exam_questionOption'
import { actionTypes as actionStatusQuestion } from './../../../redux/questionOption/select_check_questionOption_completion_status';



import ModalIncorrect from './modalncorrectQuestin';
import { handleNotificationAlertTryUpdate, handleNotificationAlertCatch } from "../../../components/method/handleNotificationAlert";


let useStyles = makeStyles(() => ({
  gridBtns: {
    width: '100%',
    display: 'flex',
    marginTop: 10,
    // margin: 'auto 5px auto 0px ',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  btnPrev: {
    border: '1px solid black',
    padding: '0.5rem 6rem',
    cursor: 'pointer',
    maxWidth: '100%',
    borderRadius: 8,
    "@media(max-width:768px)": {
      padding: '0.5rem 3.5rem',
    },
    "@media(max-width:640px)": {
      padding: '0.5rem 2.5rem',
    },
  },
  btnNext: {
    border: '0px solid black',
    padding: '0.5rem 6rem',
    cursor: 'pointer',
    maxWidth: '100%',
    borderRadius: 8,
    "@media(max-width:768px)": {
      padding: '0.5rem 3.5rem',
    },
    "@media(max-width:640px)": {
      padding: '0.5rem 2.5rem',
    },
  },
  disableBtn: {
    backgroundColor: "rgb(229,231,235)",
    color: "rgb(107,114,128)"
  },
  grid: {
    width: '100%',
    maxHeight: '63vh',
    overflow: 'auto',
  },
  '@global': {
    '*::-webkit-scrollbar': {
      backgroundColor: 'transparent',
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent',
      // outline: '1px solid slategrey'
    }
  }
}));


const QuestionModule = ({
  handleNextStep,
  handlePrevStep,
  national_id,
  setIndexChild,
  loadingOms,
  apiSubmitOms,

}) => {

  let classes = useStyles();
  let dispatch = useDispatch();


  const [indexQuestion, setIndexQuestion] = useState(0);
  const [flagStart, setflagStart] = useState(false);
  const [Score, setScore] = useState(null);
  const [loading, setLoading] = useState(false);

  const [flagIncorrect, setFlagIncorrect] = useState(false);
  const [incorrect, setIncorrect] = useState({ data: [], max_score: 0, point: 0 });



  const [sortQuestions, setSortQuestions] = useState({});
  const [stateQuestions, setStateQuestions] = useState([]);
  const [flagApiQuestions, setflagApiQuestions] = useState(false);
  const [stateTableQuestions, setStateTableQuestions] = useState({});
  const [pagnationQuestions, setPagnationQuestions] = useState({
    number: 1,
    count: 2
  });


  const stateReducer = useSelector((state) => state.reducerSelecOptionExamt);
  const reducerStatusQuestion = useSelector(state => state.reducerSelecOptionStatusCkeckQuestint)

  useEffect(() => {
    apiSubmitQuestions();
  }, [flagApiQuestions]); //eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (!flagIncorrect) {
      setIncorrect([])
    }
  }, [flagIncorrect]); //eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    // let answers = {
    //   // "1": 1,
    //   // "2": 4,
    //   // "3": 2,
    //   // "4": 3,
    //   // "5": 3,
    //   // "6": 4,
    //   // "7": 1,
    //   // "8": 3,
    //   // "9": 4,
    //   // "10": 4


    //   // "1":2,
    //   // "2":1,
    //   // "3":3,
    //   // "4":3,
    //   // "5":2,
    //   // "6":1,
    //   // "7":1,
    //   // "8":1,
    //   // "9":4,
    //   // "10":4
    // }

    let dataReverse = stateReducer.data?.reverse()
    let res = dataReverse
      ?.map((item) => {
        let answer_texts = item?.body?.answer_texts
        return (
          {
            question: item?.body?.question_text,
            // answer: answers[item?.body?.question_id],
            answer: '',
            Option: Object.keys(answer_texts)
              ?.map((child, ind) => {
                return ({
                  answer: ind + 1,
                  question: answer_texts[child]
                })
              }),
            item: item
          }
        )
      })
    setStateQuestions(res);
    setPagnationQuestions((prev) => ({
      ...prev,
      count: Math.ceil(stateReducer.total / stateReducer.size)
    }));
  }, [stateReducer?.data]); //eslint-disable-line react-hooks/exhaustive-deps



  const apiSubmitQuestions = () => {
    let obj = {};
    let { size } = stateReducer;
    let { id, ...sortRes } = sortQuestions;

    Object.keys(stateTableQuestions).forEach((element) => {
      if (stateTableQuestions[element]) {
        obj[element] = stateTableQuestions[element];
      }
    });

    let _data = {
      data: obj,
      from: pagnationQuestions.number,
      size: size,
      sort_by: sortRes
    };

    dispatch({ type: actionOnlineExam.SelectOptionExamAsync, payload: _data });
  };


  const setAnswerQuestion = (data, index) => {

    let res = stateQuestions.map((items, ind) => {
      if (index === ind) {
        return {
          ...items,
          answer: data.answer
        }
      }
      return items
    })

    setStateQuestions(res)
  }

  const handelBack = () => {
    if (indexQuestion > 0) {
      setIndexQuestion(prev => --prev)
    }
    if (indexQuestion == 0) {
      setflagStart(false)
    }
  }

  const handelNext = () => {
    if (stateQuestions[indexQuestion]?.answer && stateQuestions.length !== (indexQuestion + 1)) {
      setIndexQuestion(prev => ++prev)
    } else {
      if (stateQuestions.length === (indexQuestion + 1) && stateQuestions[stateQuestions.length - 1]?.answer) {
        apiSubmit()
      }
    }
  }

  const handelClassNameNext = () => {

    if (stateQuestions[indexQuestion]) {
      if (stateQuestions[indexQuestion]?.answer) {
        return 'bg-primaryColor text-white cursor-pointer'
      } else {
        return classes['disableBtn']
      }
    } else {
      return classes['disableBtn']
    }

  }

  const handelClassNameBack = () => {

    if (indexQuestion === 0) {
      return 'hidden'
    }

    return 'bg-white text-black'
  }

  const handleJustifyContent = () => {

    if (indexQuestion === 0) {
      return 'justify-end'
    }
    return 'justify-between'
  }


  const apiSubmit = () => {

    let obj = {}

    if (!national_id) {
      alert('لطفا کد ملی خود را وارد کنید')
      return
    }

    stateQuestions.forEach((value) => {
      obj[`${value?.item?.body?.question_id}`] = value.answer
    })


    let payload = {
      data: {
        national_id: national_id,
        answers: { ...obj },
        "exam_id": stateQuestions[0]?.item?.body?.exam_id
      }
    }

    setLoading(true)

    insert_risk_questionOption(payload)
      .then(res => {

        let isok = handleNotificationAlertTryUpdate(res);
        if (!isok) {
          return;
        }

        let point = res?.data?.response?.data?.point
        let state = res?.data?.response?.data?.state
        let max_score = stateQuestions[0]?.item?.body?.max_score

        if (state === 'true') {
          setScore(point)
        }
        else {
          // dispatch({
          //   type: actionTypesNotif.error,
          //   textAlert: `حداقل نمره قبولی ${max_score} می باشد  و نمره شما در این  آزمون ${point} شده است لطفا دوباره تلاش فرمایید`
          // });


          let point_user = 0
          let invorrect_questions = []

          if (res?.data?.response?.data?.exam_info?.points) {
            let data = res?.data?.response?.data?.exam_info?.points;
            let a = Object.keys(data)
              ?.forEach((key) => {
                if (!data[key]) {
                  invorrect_questions = [
                    ...invorrect_questions,
                    key
                  ]
                } else {
                  point_user += +data[key]
                }
              })
          }

          if (invorrect_questions?.length && point_user < max_score) {
            setIncorrect({ data: invorrect_questions, max_score: max_score, point: point })
            setFlagIncorrect(true)
          }
        }

      })
      .catch(() => {
        handleNotificationAlertCatch();
      })
      .finally(() => {
        setLoading(false)
      })
  }


  useEffect(() => {
    if (reducerStatusQuestion?.data?.state === 'ACCEPTED') {
      setScore(reducerStatusQuestion?.data?.point)
    } else {
      setScore(null)
    }
  }, [reducerStatusQuestion.data])


  useEffect(() => {
    apiStausQuestin()
  }, [national_id])

  const apiStausQuestin = () => {
    if (national_id) {
      let data = {
        "national_id": national_id
      }
      dispatch({ type: actionStatusQuestion.SelectOptionStatusCkeckQuestinAsync, payload: { data } })
    }

  }

  const hendelRestart = () => {
    setScore(null)
    setflagApiQuestions(prev => !prev)
    setIncorrect({ data: [], max_score: 0, point: 0 })
    setIndexQuestion(0)
    setFlagIncorrect(false)
    setflagStart(false)
  }


  return (
    <>
      {
        Score === null
          ? (
            <>
              {!flagStart &&
                <StartQuestion
                  data={stateQuestions}
                  setflagStart={setflagStart}
                  handlePrevStep={handlePrevStep}
                  loading={stateReducer?.loading}
                  setIndexChild={setIndexChild}
                />}
              {flagStart && (
                <BoxStyled minHeight={'auto'}>
                  <div className={classes['grid']}>
                    <StepHeader indexQuestion={indexQuestion} data={stateQuestions} />
                    <div style={{ minWidth: '50%' }}>
                      <BoxQuestion indexQuestion={indexQuestion} data={stateQuestions} />
                      <BoxAnswer indexQuestion={indexQuestion} data={stateQuestions} setAnswerQuestion={setAnswerQuestion} />

                    </div>
                  </div>
                  <div className={`${classes['gridBtns']} ${handleJustifyContent()}`}>
                    <div
                      onClick={() => handelBack()}
                      className={`${handelClassNameBack()} ${classes['btnPrev']}`}>
                      قبلی
                    </div>
                    {
                      loading
                        ? <CircularProgress />
                        : (
                          <div
                            onClick={() => handelNext()}
                            className={`${handelClassNameNext()} ${classes['btnNext']} `}>
                            {
                              stateQuestions.length === (indexQuestion + 1)
                                ? 'ثبت'
                                : 'بعدی'
                            }

                          </div>
                        )
                    }
                  </div>
                </BoxStyled>
              )}
            </>
          )
          : <EndQuestion
            score={+Score}
            handleNextStep={handleNextStep}
            handlePrevStep={handlePrevStep}
            loadingOms={loadingOms}
            apiSubmitOms={apiSubmitOms}
          />
      }
      {
        (flagIncorrect && incorrect?.data.length !== 0) && (
          <ModalIncorrect
            open={flagIncorrect}
            setOpen={setFlagIncorrect}
            data={incorrect}
            hendelRestart={() =>hendelRestart()}
          />
        )
      }
    </>
  );
};

export default QuestionModule;
